import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { Color } from 'core';
import React from 'react';
import styled from 'styled-components';

const SUPPORT_URL = 'https://www.cerego.com/blog/new-feature-release-readiness-score-measures-knowledge-in-real-time';

export const ReadinessTooltip = () => {
  const goToSupportArticle = () => {
    window.open(SUPPORT_URL, '_blank');
  };

  return (
    <LightTooltip
      title={
        <TooltipContent>
          <TooltipSection>
            <TooltipLabel>Knowledge Retention</TooltipLabel>
            <TooltipParagraph>
              Predicts how much a learner can recall <strong>right now</strong>. Unlike progress, knowledge retention
              naturally decays over time without review—this is the "forgetting curve" in action.
            </TooltipParagraph>
          </TooltipSection>
          <TooltipDivider />
          <TooltipSection>
            <TooltipLabel>Progress vs Knowledge Retention</TooltipLabel>
            <TooltipParagraph>
              <strong>Progress</strong> shows completion toward a goal (doesn't decay).
              <br />
              <strong>Knowledge Retention</strong> shows current knowledge retention (decays over time).
            </TooltipParagraph>
            <TooltipParagraph style={{ marginTop: '8px', fontStyle: 'italic' }}>
              High progress + low knowledge retention = completed but forgetting. This is why spaced repetition matters.
            </TooltipParagraph>
          </TooltipSection>
          <TooltipLink onClick={goToSupportArticle}>Learn more →</TooltipLink>
        </TooltipContent>
      }
      interactive
    >
      <TooltipButton onClick={goToSupportArticle}>
        <FontAwesomeIcon icon={faQuestionCircle} />
      </TooltipButton>
    </LightTooltip>
  );
};

const TooltipContent = styled.div`
  padding: 4px;
`;

const TooltipSection = styled.div`
  margin-bottom: 8px;
`;

const TooltipLabel = styled.div`
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 4px;
  color: ${Color.primaryBlack};
`;

const TooltipParagraph = styled.p`
  font-size: 13px;
  line-height: 1.4;
  margin: 0;
`;

const TooltipDivider = styled.div`
  height: 1px;
  background-color: ${Color.lightGray};
  margin: 12px 0;
`;

const TooltipLink = styled.span`
  display: inline-block;
  margin-top: 8px;
  font-size: 12px;
  color: ${Color.primaryBlue};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const TooltipButton = styled.button`
  border: none;
  background: transparent;
  color: ${Color.reportGray};
  cursor: pointer;
  padding: 4px;

  &:hover {
    color: ${Color.primaryBlue};
  }
`;

const LightTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: Color.white,
    color: Color.primaryBlack,
    border: `1px solid ${Color.reportGray}`,
    boxShadow: `3px 3px 3px ${Color.reportGray}`,
    maxWidth: 320,
    padding: '12px',
  },
}))(Tooltip);
